 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0943506c":"01abb1bb","chunk-1b1f9a78":"c046e9c1","chunk-1e249582":"fa3cbca0","chunk-0f8a5c7c":"93b64477","chunk-5adb0b7e":"58ae943d","chunk-70d67a8c":"5b2bc2ba","chunk-74546d18":"46329c5d","chunk-7c218680":"8aa1eac4","chunk-f8da15a2":"430c6eb7","chunk-46a0bde5":"ab87cfef","chunk-4a06d6b6":"b784ee32","chunk-72e585b3":"b3422f57","chunk-850abea2":"1298d663","chunk-d9582bf2":"a091bf7b","chunk-2712c8d2":"ed308a21","chunk-34254e12":"af4fadda","chunk-48730df8":"3c3c310a","chunk-5f9cef43":"2f1b189a","chunk-8cb3755c":"d31240a2","chunk-e07c4720":"84ed8a03","chunk-083bc001":"42e18c0f","chunk-147da530":"b4e8a78f","chunk-1c6a1ef2":"ff2ecfdf","chunk-24966d50":"b70193e6","chunk-27304210":"679e6a9e","chunk-2e9577b4":"3e9b8b6d","chunk-2edd4a52":"ab3642da","chunk-39246ade":"ac068d9a","chunk-3b2ef9cb":"81800ab7","chunk-47b2c6bb":"650f935f","chunk-56f1d050":"487f5dc5","chunk-5a956b7e":"b66e7667","chunk-6b4d95e6":"d7b2a87f","chunk-6d094f5c":"0d104a85","chunk-6d86f7ab":"d067e0a5","chunk-b9122a58":"bf88a62b","chunk-19e52b0f":"17b2c5a1","chunk-1a64f2c8":"77421e07","chunk-fb00ada2":"558942e6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0943506c":1,"chunk-1e249582":1,"chunk-0f8a5c7c":1,"chunk-5adb0b7e":1,"chunk-70d67a8c":1,"chunk-74546d18":1,"chunk-7c218680":1,"chunk-f8da15a2":1,"chunk-46a0bde5":1,"chunk-4a06d6b6":1,"chunk-72e585b3":1,"chunk-850abea2":1,"chunk-d9582bf2":1,"chunk-2712c8d2":1,"chunk-34254e12":1,"chunk-48730df8":1,"chunk-5f9cef43":1,"chunk-8cb3755c":1,"chunk-e07c4720":1,"chunk-083bc001":1,"chunk-147da530":1,"chunk-1c6a1ef2":1,"chunk-24966d50":1,"chunk-27304210":1,"chunk-2e9577b4":1,"chunk-2edd4a52":1,"chunk-39246ade":1,"chunk-3b2ef9cb":1,"chunk-47b2c6bb":1,"chunk-56f1d050":1,"chunk-5a956b7e":1,"chunk-6b4d95e6":1,"chunk-6d094f5c":1,"chunk-6d86f7ab":1,"chunk-b9122a58":1,"chunk-19e52b0f":1,"chunk-1a64f2c8":1,"chunk-fb00ada2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0943506c":"4d2a7bd0","chunk-1b1f9a78":"31d6cfe0","chunk-1e249582":"5259cd02","chunk-0f8a5c7c":"6276d6ae","chunk-5adb0b7e":"7fed3ff6","chunk-70d67a8c":"8512410b","chunk-74546d18":"6e3e750c","chunk-7c218680":"8df2c5ca","chunk-f8da15a2":"5d25309e","chunk-46a0bde5":"182ec774","chunk-4a06d6b6":"b0e56721","chunk-72e585b3":"72d9a374","chunk-850abea2":"7904d52c","chunk-d9582bf2":"6584c379","chunk-2712c8d2":"435da5dd","chunk-34254e12":"b86f5b3a","chunk-48730df8":"224ed65b","chunk-5f9cef43":"0f99f2e0","chunk-8cb3755c":"80233b63","chunk-e07c4720":"88b12eea","chunk-083bc001":"cdff082c","chunk-147da530":"a5c69a34","chunk-1c6a1ef2":"9d5be8bd","chunk-24966d50":"9a784b1d","chunk-27304210":"ed792767","chunk-2e9577b4":"7dbd2ea5","chunk-2edd4a52":"2376cff6","chunk-39246ade":"7b9ef3c4","chunk-3b2ef9cb":"374c36b5","chunk-47b2c6bb":"e3e69e7f","chunk-56f1d050":"51d7f0c1","chunk-5a956b7e":"1facbd52","chunk-6b4d95e6":"4560b2a0","chunk-6d094f5c":"26b70227","chunk-6d86f7ab":"b22314fa","chunk-b9122a58":"272271c9","chunk-19e52b0f":"37b4982e","chunk-1a64f2c8":"9bf83833","chunk-fb00ada2":"0aca7ec2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/spa/app-analytics/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
